import React, { PureComponent } from 'react';
import { translate } from '../../utils/translations';
import PropTypes from 'prop-types';
import { Form8d48h } from './Form8d48h/Form8d48h';
import { FormSimple } from './FormSimple/FormSimple';
import { DEFAULT_CONFIG } from '../../utils/globals';
import { debounce } from '../../utils/utils';

import Municipal72h from '../Municipal48h/Municipal48h';
import Municipal8d from '../Municipal8d/Municipal8d';
import MapaPrediccio from '../MapaPrediccio/MapaPrediccio';
import MapaRadar from '../MapaRadar/MapaRadar';
import MapaAvisos from '../MapaAvisos/MapaAvisos';
import MapaAramet from '../MapaAramet/MapaAramet';

/**
 * This component wraps: Heading, Description, Widget preview and
 * Widget Config Form and renders altogether into Configurador Component
 */

const {
    location,
    color,
    alternativeTitle,
    tempFormat,
    windSpeedFormat,
    mainChart,
    secondaryChart,
} = DEFAULT_CONFIG;

export class Wrapper extends PureComponent {
    state = {
        toggle: false,
        formHeight: 0,
        formOpacity: 0,
        location,
        color,
        alternativeTitle,
        language: this.props.language,
        tempFormat,
        // Municipal72h
        windSpeedFormat,
        mainChart,
        secondaryChart,
    };

    static propTypes = {
        language: PropTypes.string,
        translationCode: PropTypes.string,
        widget: PropTypes.string,
    };

    components = {
        municipal8d: Municipal8d,
        municipal72h: Municipal72h,
        mapaRadar: MapaRadar,
        mapaAvisos: MapaAvisos,
        mapaPrediccio: MapaPrediccio,
        mapaAramet: MapaAramet
    };

    forms = {
        form8d48h: Form8d48h,
        formSimple: FormSimple,
    };

    render() {
        const { formHeight, formOpacity } = this.state;
        return (
            <React.Fragment>
                <h2 className="configurador__heading">
                    {translate(
                        this.props.language,
                        `config_${this.props.translationCode}_heading`
                    )}.{' '}
                    <span
                        className="widget-toggle"
                        onClick={this.toggleWidgetPreview}
                    >
                        {translate(this.props.language, 'config_toggle')}
                        {this.renderChevron()}
                    </span>
                </h2>
                <hr />
                <div className="configurador__single-wrapper">
                    <p className="configurador__descriptions">
                        {translate(
                            this.props.language,
                            `config_${this.props.translationCode}_description`
                        )}
                    </p>
                    <div className="configurador__widget-wrapper">
                        {this.renderWidget()}
                    </div>
                    <div
                        className="configurador__form-wrapper"
                        style={{
                            maxHeight: formHeight,
                            opacity: formOpacity,
                            visibility: formHeight === 0 ? 'hidden' : 'visible',
                            marginTop: formHeight === 0 ? '0' : '43px',
                        }}
                        key={1}
                    >
                        {this.renderForm()}
                    </div>
                </div>
            </React.Fragment>
        );
    }

    toggleWidgetPreview = event => {
        this.setState(prevState => ({
            toggle: !prevState.toggle,
            formHeight: prevState.formHeight === 0 ? 'unset' : 0,
            formOpacity: prevState.formOpacity === 0 ? 1 : 0,
        }));

        const offsetTop = event.target.offsetTop;
        setTimeout(() => {
            window.scroll({
                top: offsetTop,
                left: 0,
                behavior: 'smooth',
            });
        }, 500);
    };

    renderChevron = () => {
        const transform = 'rotate(180deg) translate(-5px, -8px)';
        const style = this.state.toggle
            ? {
                  transform: transform,
                  WebkitTransform: transform,
              }
            : null;

        return (
            <svg aria-hidden="true" viewBox="0 0 320 512" style={style}>
                <path
                    fill="currentColor"
                    d="M151.5 347.8L3.5 201c-4.7-4.7-4.7-12.3 0-17l19.8-19.8c4.7-4.7 12.3-4.7 17 0L160 282.7l119.7-118.5c4.7-4.7 12.3-4.7 17 0l19.8 19.8c4.7 4.7 4.7 12.3 0 17l-148 146.8c-4.7 4.7-12.3 4.7-17 0z"
                />
            </svg>
        );
    };

    renderWidget = () => {
        const { widget } = this.props;

        const availableWidgets = {
            municipal72h: true,
            municipal8d: true,
            mapaPrediccio: true,
            mapaRadar: true,
            mapaAvisos: true,
            mapaAramet: true,
        };

        const isWidgetAvailable = availableWidgets[widget];
        if (!isWidgetAvailable) return;

        const WidgetName = this.components[widget];
        const {
            location,
            color,
            alternativeTitle,
            language,
            tempFormat,
            windSpeedFormat,
            mainChart,
            secondaryChart,
        } = this.state;
        return (
            <WidgetName
                location={location}
                color={color}
                alternativeTitle={alternativeTitle}
                language={language}
                tempFormat={tempFormat}
                windSpeedFormat={
                    widget === 'municipal72h' ? windSpeedFormat : undefined
                }
                mainChart={widget === 'municipal72h' ? mainChart : undefined}
                secondaryChart={
                    widget === 'municipal72h' ? secondaryChart : undefined
                }
                preview={true}
            />
        );
    };

    renderForm = () => {
        const FormName = this.forms[this.props.form];
        return (
            <FormName
                language={this.props.language}
                updateWidget={this.updateWidget}
                updateAltTitle={this.updateAltTitle}
                widget={this.props.widget}
            />
        );
    };

    updateWidget = debounce((key, value) => {
        // we dont want the widget to update without location
        if (key[0] === 'location' && value === '') return;
        this.setState({ [key]: value });
    });

    updateAltTitle = (key, value) => {
        this.setState({ [key]: value });
    };
}



// WEBPACK FOOTER //
// ./src/containers/Configurador/Wrapper.js